import { CoursesModule } from './courses/courses.module';
import { TestsModule } from './tests/tests.module';
import { FeedbackStyleTwoComponent } from './common/feedback-style-two/feedback-style-two.component';
import { OurValuesComponent } from './common/our-values/our-values.component';
import { OurStoryComponent } from './common/our-story/our-story.component';
import { OurMissionComponent } from './common/our-mission/our-mission.component';
import { AboutPageOneComponent } from './common/about-page-one/about-page-one.component';
import { ContactListComponent } from './common/contact-list/contact-list.component';
import { ErrorPageComponent } from './common/error-page/error-page.component';
import { FeedbackStyleOneComponent } from './common/feedback-style-one/feedback-style-one.component';
import { FunfactsComponent } from './common/funfacts/funfacts.component';
import { FeaturesComponent } from './common/features/features.component';
import { HeaderStyleFourComponent } from './core/header-style-four/header-style-four.component';
import { ComingSoonPageComponent } from './common/coming-soon-page/coming-soon-page.component';
import { LoginPageComponent } from './auth/login-page/login-page.component';
import { FooterComponent } from './core/footer/footer.component';
import { PreloaderComponent } from './common/preloader/preloader.component';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { AngularFirestoreModule } from '@angular/fire/firestore';
import { AngularFireModule } from '@angular/fire';
import { environment } from '../environments/environment';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule } from '@angular/forms';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { StudentModule } from './student/student.module';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { InstructorsStyleTwoComponent } from './common/instructors-style-two/instructors-style-two.component';
import { HomePageComponent } from './home-page/home-page.component';
import { MainBannerComponent } from './home-page/main-banner/main-banner.component';
import { CoursesBlockComponent } from './home-page/courses-block/courses-block.component';
import { ExamsBlockComponent } from './home-page/exams-block/exams-block.component';
import {SubjectTestsModule} from './subject-tests/subject-tests.module';

@NgModule({
  declarations: [
    AppComponent,
    HeaderStyleFourComponent,
    FeaturesComponent,
    PreloaderComponent,
    FooterComponent,
    LoginPageComponent,
    ComingSoonPageComponent,
    FunfactsComponent,
    FeedbackStyleOneComponent,
    ErrorPageComponent,
    AboutPageOneComponent,
    ContactListComponent,
    OurMissionComponent,
    OurStoryComponent,
    OurValuesComponent,
    FeedbackStyleTwoComponent,
    InstructorsStyleTwoComponent,
    HomePageComponent,
    MainBannerComponent,
    CoursesBlockComponent,
    ExamsBlockComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFirestoreModule,
    BrowserAnimationsModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: httpTranslateLoader,
        deps: [HttpClient]
      }
    }),
    FormsModule,
    HttpClientModule,
    StudentModule,
    // TestsModule,
    SubjectTestsModule,
    CoursesModule],
  providers: [],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]

})
export class AppModule { }

// AOT compilation support
// tslint:disable-next-line:typedef
export function httpTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http);
}
